module.exports = __webpack_public_path__ + "static/media/nunito-sans-v15-cyrillic_cyrillic-ext_latin_latin-ext_vietnamese-300italic.e81ba11e.woff2";